import * as Cookies from 'js-cookie'

import { Consent, userHasOptedOutOfCookiesForCategory } from './consent'
import { removeCookie } from './cookieHelper'

const getNumericValueOfString = (string: string) =>
  Array.from(string)
    .map(e => e.charCodeAt(0))
    .reduce((memo, value) => memo + value)

const byNumericValue = (a: string, b: string) => {
  const firstElement = getNumericValueOfString(a)
  const secondElement = getNumericValueOfString(b)

  if (firstElement < secondElement) {
    return -1
  }

  if (firstElement > secondElement) {
    return 1
  }

  return 0
}

const removeTrackerStorage = () => {
  const path = '/'

  /* eslint-disable banhammer/no-restricted-functions */
  const cookies = Cookies.get()
  /* eslint-enable banhammer/no-restricted-functions */

  const sortedCookies = Object.keys(cookies)
    .sort(byNumericValue)
    .reverse()

  sortedCookies
    .filter(key => RegExp('^market_experiment_').test(key))
    .forEach(match => {
      removeCookie({ itemKey: match, cookieOptions: { path } })
    })
}

const handleCookiebotAcceptDeclineEvent = () => {
  if (userHasOptedOutOfCookiesForCategory(Consent.preferences)) {
    removeTrackerStorage()
  }
}

export const handleExperimentOptedOutEvent = () => {
  if (typeof window !== 'undefined') {
    window.addEventListener(
      'CookiebotOnAccept',
      handleCookiebotAcceptDeclineEvent
    )
    window.addEventListener(
      'CookiebotOnDecline',
      handleCookiebotAcceptDeclineEvent
    )
  }
}
